import { Box, Title } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { VonqCampaignsTable } from 'modules/ats/components/VonqCampaignsTable'
import { CampaignStatus, ProductDuration, buildCampaignWithProducts } from 'modules/ats/lib/vonq'

import { useGetJobCampaigns } from './useGetJobCampaigns'

type TableProduct = {
  id: string
  name: string
  status: CampaignStatus
  publishedAt: string | null
  durationPeriod: ProductDuration
  visits: number
}

interface Props {
  jobId: number
}

export const VonqCampaigns = ({ jobId }: Props) => {
  const { loading, campaigns } = useGetJobCampaigns(jobId)

  const campaignsWithProducts = campaigns.map(buildCampaignWithProducts)

  if (loading || campaigns.length === 0) {
    return null
  }

  return (
    <Box gap="s24">
      <Title
        variant="500"
        title={i18n.t('ats.vonq.campaigns_list.title')}
        description={i18n.t('ats.vonq.campaigns_list.description')}
      />

      <VonqCampaignsTable campaigns={campaignsWithProducts} />
    </Box>
  )
}
